import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import dayjs, { Dayjs } from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import { IPanDetails, IReSendEmailOTP, ISendEmail } from "../shared/dtos";
import otpIcon from "../Components/assets/Images/otpIcon.svg";
import {
  CompleteAadhaarAPICall,
  digiLockerInitAPICall,
  panDetailsAPICall,
  reSendEmailOTPAPICall,
  sendEmialAPICall,
  stageDetailsAPICall,
  startOverAPICall,
} from "../shared/APICalls";
import routesData from "../shared/routes.json";
import PanStyles from "../pages/Styles/PanVerification.module.scss";
import calenderImage from "../Components/assets/Images/calendar.svg";
import SnackBar from "../Components/SnackBars/SnackBar";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import keyboardicon from "../Components/assets/Images/stepkeyboard.svg";
import { useDispatch } from "react-redux";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";
import { confirmAlert } from "react-confirm-alert";
import BackDrop from "../Components/BackDrop";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import TagManager from "react-gtm-module";
import ProgressComp from "../Components/ProgressComp/ProgressComp";
import ContinueWithGoogle from "../Components/ContinueWithGoogle/ContinueWithGoogle";
import ContinueWithGoogleNew from "../Components/ContinueWithGoogle/ContinueWithGoogleNew";
import SucessSnackBar from "../Components/SnackBars/SucesssnackBar";
import { isMobile } from "react-device-detect";
import KRAScreen from "./KRAscreen";
import SideBar from "../Components/SideBar/SideBar";

import ProgressBar from "../Components/ProgressBar/ProgressBar";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MenuIcon from "@mui/icons-material/Menu";

const schema = Yup.object().shape({
  fullName: Yup.string()
    .required("Name is Required")
    .min(3, "Minimum 3 letters is required")
    .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
    // .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .max(50)
    .transform((value: any) => value && value.toUpperCase()),
  pannumber: Yup.string()
    .required("Pan Number is Required")
    .max(10)
    .matches(
      /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
      "Enter Valid Pan Number",
    )
    .transform((value: any) => value && value.toUpperCase()),
});

function DateIcon(props) {
  return (
    <img src={calenderImage} style={{ width: "25px", paddingRight: "8px" }} />
  );
}

const dots = ["1", "2", "3", "4", "5", "6"];

export default function PanVerificationPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dobError, setDobError] = useState("");
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState<any>("");
  const [panPrefill, setPanPrefill] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [emailotp, setEmailotp] = useState("");
  const [emailtyped, setEmailtyped] = useState("");
  const [emailGoogle, setEmailGoogle] = useState("");
  const [dobPrefill, setPanDobfill] = useState<any>("");
  const [prefilloading, setprefilloading] = useState(true);
  const [rejectMessage, setRejectMessage] = useState("");
  const [disablePan, setDisablePan] = useState(false);
  const [open, setOpen] = React.useState(true);
  const [backdrop, setBackDrop] = useState(false);
  const [backdropLoading, setbackdropLoading] = useState(false);
  const [getloading, setGetloading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const navigationData = routesData;
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [countdown, setCountdown] = useState<any>(30);
  const [timerId, setTimerId] = useState<any>(null);
  const [otpSent, setOtpSent] = useState(false);
  const [isGoogleVerified, setIsGoogleVerified] = useState(false);
  const [kraFetched, setKraFetched] = useState(false);
  const [KraData, setKraData] = useState<any>();
  const [expandMenu, setExpandMenu] = useState<any>(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);

    let obj: any = {
      stage: "pan",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        setprefilloading(false);
        const responseData = response.data;
        dispatch(setCompletedStages(responseData?.data?.completed_stages));
        dispatch(setCurrentStage(responseData?.data?.current_stage));

        setRejectMessage(response?.data?.data?.ErrorMessage);
        setPanPrefill(response?.data?.data?.data?.pan_no);
        if (response?.data?.data?.data?.dob) {
          setPanDobfill(dayjs(response?.data?.data?.data?.dob));
        }
        if (response?.data?.data?.data?.pan_no) {
          setDisablePan(true);
        }
        if (response?.data?.data?.data?.pan_name) {
          setFullName(response?.data?.data?.data?.pan_name);
        }
        if (response?.data?.data?.data?.email) {
          setEmail(response?.data?.data?.data?.email);
        }
        if (response?.data?.data?.data?.is_google_verified) {
          setIsGoogleVerified(response?.data?.data?.data?.is_google_verified);
          setEmailotp("123456");
        }
      })
      .catch((error: any) => {
        setprefilloading(false);
      });
  }, []);

  useEffect(() => {
    if (countdown <= 0 && timerId !== null) {
      setIsButtonDisabled(false);

      clearInterval(timerId);
      setTimerId(null);
    }
  }, [countdown]);

  function panDetails(values: any, name: any) {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitPan",
      },
    });

    setloading(true);
    let obj: any = {
      pan_no: values?.pannumber?.toUpperCase(),
      // dob: date,
      email: values?.email,
      email_otp: isGoogleVerified ? "" : values.emailotp,
      email_authorize: isGoogleVerified,
    };
    // console.log("obj", obj);
    panDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response?.data;

        // console.log("responseData", responseData);

        if (!responseData) {
          setMessage("Failed to get Data");
          setTimeout(() => {
            setMessage("");
          }, 5000);
        }
        setloading(false);

        if (responseData.data?.next_stage === "kra_or_aadhaar") {
          if (responseData.data.is_kra_fetched) {
            setKraData(responseData.data.kra);
            setKraFetched(true);
          } else {
            handleDigilocker();
          }
        } else {
          if (
            responseData?.data?.next_stage &&
            navigationData.hasOwnProperty(responseData?.data?.next_stage)
          ) {
            navigate(navigationData[responseData?.data?.next_stage]);
          }
        }
      })
      .catch((error: any) => {
        //console.log("error", error);
        setloading(false);

        setMessage(
          error?.message.includes("Network")
            ? "Error Occured, Please try again"
            : error?.response?.data?.message,
        );

        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  const handleDigilocker = () => {
    setloading(true);
    let digilink: string = "";

    let obj: any = {
      digi_redirect_type: "ekyc_aadhaar",
    };
    digiLockerInitAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // setloading(false);
        // console.log("responseData", responseData);
        digilink = responseData.data.link;

        window.location.href = digilink;
      })
      .catch((error: any) => {
        setloading(false);
      });
  };

  const CompleteAadhaarStage = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitAadhaar",
      },
    });

    CompleteAadhaarAPICall()
      .then((response: any) => {
        // console.log("response", response.data.data.next_stage);
        if (
          response.data.data.next_stage &&
          navigationData.hasOwnProperty(response.data.data.next_stage)
        ) {
          navigate(navigationData[response.data.data.next_stage]);
        }
      })
      .catch((error: any) => {});
  };

  const handleClick = (values: any, name: any) => {
    panDetails(values, name);
  };

  return (
    <>
      <SucessSnackBar message={successMessage} />

      <ErrorSnackBar message={rejectMessage} />
      <SnackBar message={message} />
      <div>{backdrop && <StartOverBackDrop />}</div>
      <>
        <div className={PanStyles.layout}>
          <div className={PanStyles.sidebar}>
            <SideBar />
          </div>
          <div className={PanStyles.pageContent}>
            <div className={PanStyles.mainWrapper}>
              {!kraFetched ? (
                <>
                  {prefilloading && (
                    <Backdrop
                      sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                      }}
                      open={open}
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  )}
                  <div className={PanStyles.wrapper}>
                    <div className={PanStyles.RightContainer}>
                      {!prefilloading ? (
                        <>
                          <Formik
                            validationSchema={schema}
                            initialValues={{
                              fullName: fullName === "" ? "" : fullName,
                              pannumber: panPrefill === "" ? "" : panPrefill,
                            }}
                            onSubmit={(values: any) => {
                              const formatDate = "";

                              handleClick(values, fullName);
                            }}
                          >
                            {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              setFieldValue,
                            }) => {
                              // console.log("errors", errors);
                              // console.log("values", values);
                              return (
                                <>
                                  <form
                                    noValidate
                                    onSubmit={handleSubmit}
                                    onKeyDown={(event) => {
                                      event.code === "Enter" ||
                                        (event.code === "NumpadEnter" &&
                                          handleSubmit());
                                      // event.code.includes("Enter") && handleSubmit()
                                    }}
                                    // style={{ width: "100%" }}
                                  >
                                    <div className={PanStyles.feildsWrapper}>
                                      <div className={PanStyles.headerSection}>
                                        <p className={PanStyles.signup}>
                                          <div className={PanStyles.mobileBack}>
                                            {/* <ArrowBackIosIcon /> */}
                                          </div>
                                          Verify Your Details
                                          <div
                                            className={PanStyles.mobileMenu}
                                            onClick={() => {
                                              setExpandMenu(!expandMenu);
                                            }}
                                          >
                                            {expandMenu ? (
                                              <CloseIcon />
                                            ) : (
                                              <MenuIcon />
                                            )}
                                          </div>
                                        </p>
                                        <ProgressBar />
                                        <div
                                          className={
                                            PanStyles.mobileexpandedMenu
                                          }
                                          style={{
                                            height: expandMenu ? "100%" : "0%",
                                          }}
                                        >
                                          <div
                                            className={
                                              PanStyles.mobilemenuContent
                                            }
                                          >
                                            <SideBar />
                                          </div>
                                        </div>
                                        <p className={PanStyles.subText}>
                                          {/* Your PAN is needed to verify your identity */}
                                          {panPrefill === ""
                                            ? "Your PAN is needed to verify your identity"
                                            : "Review your Name and PAN details. Update if incorrect or enter them if not auto-filled."}
                                        </p>
                                      </div>
                                      <div
                                        className={PanStyles.textfeildSection}
                                      >
                                        <div className={PanStyles.textWrap}>
                                          <div className={PanStyles.labeltext}>
                                            Full Name{" "}
                                          </div>
                                          <TextField
                                            autoComplete="off"
                                            sx={{
                                              fieldset: {
                                                borderColor: "#E7EAEE",
                                                // borderRadius: "100px",
                                              },
                                            }}
                                            className={PanStyles.textfeild}
                                            id="outlined-basic"
                                            // label="PAN"
                                            name="fullName"
                                            placeholder="Full Name"
                                            variant="outlined"
                                            value={values.fullName.toUpperCase()}
                                            error={
                                              touched.fullName &&
                                              Boolean(errors.fullName)
                                            }
                                            helperText={
                                              touched.fullName &&
                                              errors.fullName?.toString()
                                            }
                                            InputLabelProps={{
                                              sx: {
                                                color: "var(--ds-text-primary)",
                                                fontWeight: 400,
                                                fontSize: "14px",
                                                "&.MuiFormLabel-filled": {
                                                  color: "#111827",
                                                  fontWeight: 400,
                                                  fontSize: "15px",
                                                  fontFamily: "inherit",
                                                },
                                              },
                                            }}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            inputProps={{
                                              sx: {
                                                "&::label": {
                                                  // fill: "#111827",
                                                  fontWeight: 400,
                                                  fontSize: "14px",
                                                },
                                                color: "var(--ds-text-primary)",
                                                fontSize: "14px",
                                                "&::placeholder": {
                                                  color:
                                                    "var(--ds-text-secondary)",
                                                  fontWeight: 400,
                                                  fontSize: "14px",
                                                  opacity: 0.6,
                                                },
                                              },
                                              // maxLength: 10,
                                            }}
                                            // disabled={disablePan}
                                          />
                                        </div>
                                        <div className={PanStyles.textWrap}>
                                          <div className={PanStyles.labeltext}>
                                            PAN{" "}
                                          </div>
                                          <TextField
                                            autoComplete="off"
                                            sx={{
                                              fieldset: {
                                                borderColor: "#E7EAEE",
                                                // borderRadius: "100px",
                                              },
                                            }}
                                            className={PanStyles.textfeild}
                                            id="outlined-basic"
                                            // label="PAN"
                                            name="pannumber"
                                            placeholder="PAN"
                                            variant="outlined"
                                            value={values.pannumber.toUpperCase()}
                                            error={
                                              touched.pannumber &&
                                              Boolean(errors.pannumber)
                                            }
                                            helperText={
                                              touched.pannumber &&
                                              errors.pannumber?.toString()
                                            }
                                            InputLabelProps={{
                                              sx: {
                                                color:
                                                  "var(--ds-text-secondary)",
                                                fontWeight: 400,
                                                fontSize: "14px",
                                                "&.MuiFormLabel-filled": {
                                                  color: "#111827",
                                                  fontWeight: 400,
                                                  fontSize: "15px",
                                                  fontFamily: "inherit",
                                                },
                                              },
                                            }}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            inputProps={{
                                              sx: {
                                                "&::label": {
                                                  color:
                                                    "var(--ds-text-primary)",
                                                  fontWeight: 400,
                                                  fontSize: "14px",
                                                },
                                                color: "var(--ds-text-primary)",
                                                fontSize: "14px",
                                                "&::placeholder": {
                                                  color:
                                                    "var(--ds-text-secondary)",
                                                  fontWeight: 400,
                                                  fontSize: "14px",
                                                  opacity: 0.6,
                                                },
                                              },
                                              maxLength: 10,
                                            }}
                                            // disabled={disablePan}
                                          />
                                        </div>
                                      </div>
                                      {/* <div className={PanStyles.emailSection}>
                                        Email verification
                                      </div> */}
                                      {/* <div className={PanStyles.divider}></div> */}

                                      {/* <div className={PanStyles.emailDetails}>
                                        <div className={PanStyles.feilditems}>
                                          <div
                                            style={{
                                              position: "relative",
                                              // width: !isGoogleVerified ? "" : "100%",
                                            }}
                                            className={PanStyles.feilditemsDiv}
                                          >
                                            <div
                                              className={PanStyles.labeltext}
                                            >
                                              Email{" "}
                                            </div>
                                            <TextField
                                              autoComplete="off"
                                              sx={{
                                                fieldset: {
                                                  borderColor: "#E7EAEE",
                                                  // borderRadius: "100px",
                                                },
                                              }}
                                              inputProps={{
                                                maxLength: 75,
                                                onKeyDown: (e) =>
                                                  e.key === " " &&
                                                  e.preventDefault(), // Prevents typing space
                                                onInput: (e) =>
                                                  (e.currentTarget.value =
                                                    e.currentTarget.value.replace(
                                                      /\s/g,
                                                      "",
                                                    )),
                                                sx: {
                                                  "&::label": {
                                                    fill: "#111827",
                                                    fontWeight: 400,
                                                    fontSize: "14px",
                                                  },
                                                  color: "#121923",
                                                  fontSize: "14px",
                                                  "&::placeholder": {
                                                    color: "#6B7280",
                                                    fontWeight: 400,
                                                    fontSize: "14px",
                                                    opacity: 0.6,
                                                  },
                                                },
                                              }}
                                              className={
                                                PanStyles.textfieldEmail
                                              }
                                              name="email"
                                              value={values.email}
                                              error={
                                                touched.email &&
                                                Boolean(errors.email)
                                              }
                                         
                                              onChange={(event: any) => {
                                                if (
                                                  event.target.value ===
                                                  emailGoogle
                                                ) {
                                                  setIsGoogleVerified(true);
                                                  setFieldValue(
                                                    "emailotp",
                                                    "123456",
                                                  );
                                                } else {
                                                  setIsGoogleVerified(false);
                                                  setFieldValue("emailotp", "");
                                                }

                                                handleChange(event);
                                              }}
                                              onBlur={handleBlur}
                                              id="outlined-basic"
                                              label=""
                                              placeholder="Email"
                                              variant="outlined"
                                              InputProps={{
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                    <div
                                                      className={
                                                        PanStyles.google
                                                      }
                                                    >
                                                      <ContinueWithGoogle
                                                        handleCallBack={
                                                          callBackMessage
                                                        }
                                                        handleCallBackSuccess={(
                                                          googleData: any,
                                                        ) => {
                                                          setFieldValue(
                                                            "email",
                                                            googleData?.email,
                                                          );
                                                          setOtpSent(false);
                                                          setFieldValue(
                                                            "emailotp",
                                                            "123456",
                                                          );
                                                          handleCallBackSuccess(
                                                            googleData,
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                  </InputAdornment>
                                                ),
                                              }}
                                            />
                                            <FormHelperText
                                              style={{
                                                color: "#d32f2f",
                                                height: "10px",
                                                marginTop: "3px",
                                                textAlign: "center",
                                                position: "absolute",
                                                width: "100%",
                                              }}
                                            >
                                              {touched.email &&
                                                errors.email?.toString()}
                                            </FormHelperText>
                                          </div>
                                         
                                          <>
                                            {values.email && (
                                              <>
                                                {!isGoogleVerified && (
                                                  <>
                                                    {emailGoogle !==
                                                      values.email && (
                                                      <>
                                                        {emailtyped !==
                                                        values.email ? (
                                                          <Button
                                                            disableElevation
                                                            disableFocusRipple
                                                            disableTouchRipple
                                                            variant="outlined"
                                                            size="small"
                                                            sx={{
                                                              width: "80px",
                                                              height:
                                                                "max-content",

                                                              color: "#414651",
                                                              fontSize: "12px",
                                                              fontWeight: 400,
                                                              // padding: "4px",
                                                            }}
                                                            onClick={() => {
                                                              if (!getloading) {
                                                                sendEmailAddress(
                                                                  values.email,
                                                                  values.fullName,
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            {getloading ? (
                                                              <CircularProgress
                                                                style={{
                                                                  color:
                                                                    "inherit",
                                                                  width: "20px",
                                                                  height:
                                                                    "20px",
                                                                }}
                                                              />
                                                            ) : (
                                                              "Get OTP"
                                                            )}
                                                          </Button>
                                                        ) : (
                                                          <Button
                                                            disableElevation
                                                            disableFocusRipple
                                                            disableTouchRipple
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={
                                                              isButtonDisabled
                                                            }
                                                            sx={{
                                                              width: "80px",

                                                              color: "#414651",
                                                              fontSize: "12px",
                                                              fontWeight: 400,
                                                              // padding: "4px",

                                                              "&.Mui-disabled":
                                                                {
                                                                  // background:
                                                                  //   "#3263E5 !important",
                                                                  color: "#000",
                                                                  opacity: 0.5,
                                                                },
                                                            }}
                                                            onClick={() => {
                                                              setFieldValue(
                                                                "mobileotp",
                                                                "",
                                                              );
                                                              handleResendOTP(
                                                                values,
                                                              );
                                                            }}
                                                          >
                                                            Resend
                                                          </Button>
                                                        )}
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            )}
                                          </>
                                          
                                        </div>
                                        {otpSent && (
                                          <>
                                            <div
                                              className={
                                                PanStyles.otpfeilditems
                                              }
                                              style={{ position: "relative" }}
                                            >
                                              <MuiOtpInput
                                                length={6}
                                                value={values.emailotp}
                                                autoFocus
                                                onChange={(event: any) => {
                                                  const updatedValue = event;

                                                  // setFieldValue(
                                                  //   "emailotp",
                                                  //   updatedValue,
                                                  // );
                                                  handleChangeField(
                                                    "emailotp",
                                                    updatedValue,
                                                    setFieldValue,
                                                    values,
                                                  );
                                                }}
                                                inputMode="numeric"
                                                onKeyPress={handleKeyPress}
                                                sx={{
                                                  "& .MuiOutlinedInput-root": {
                                                    borderRadius: 0,
                                                    borderBottom:
                                                      "1.5px solid #EDEDED !important",

                                                    "& fieldset": {
                                                      border: "none",
                                                    },

                                                    "&:hover fieldset": {
                                                      border: "none",
                                                    },

                                                    "&.Mui-focused fieldset": {
                                                      border: "none",
                                                    },
                                                  },
                                                  "& .MuiOutlinedInput-root.Mui-focused":
                                                    {
                                                      borderBottom:
                                                        "1.5px solid #535862 !important", // 🔵 focus color
                                                    },

                                                  "& .MuiOutlinedInput-input": {
                                                    borderRadius: 0,
                                                    padding: "0px !important",
                                                    height: "60px",
                                                    background: "transparent",
                                                  },
                                                }}
                                              />
                                         
                                              <FormHelperText
                                                style={{
                                                  color: "#d32f2f",
                                                  height: "10px",
                                                  marginTop: "3px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                {touched.emailotp &&
                                                  errors.emailotp?.toString()}
                                              </FormHelperText>
                                      
                                            </div>

                                            {isButtonDisabled ? (
                                              <div
                                                className={
                                                  PanStyles.resendSection
                                                }
                                              >
                                                <p
                                                  className={
                                                    PanStyles.clickhere
                                                  }
                                                >
                                                  Resend OTP in{" "}
                                                  <span
                                                    style={{ color: "#3263E5" }}
                                                  >
                                                    {countdown}
                                                  </span>{" "}
                                                  Seconds
                                                </p>
                                              </div>
                                            ) : (
                                              <div
                                                className={
                                                  PanStyles.resendSection
                                                }
                                              ></div>
                                            )}
                                          </>
                                        )}

                                        <div className={PanStyles.mobilebottom}>
                                          <div className={PanStyles.ordiv}>
                                            <div
                                              className={PanStyles.divid}
                                            ></div>
                                            <div
                                              className={PanStyles.ortextmob}
                                            >
                                              or
                                            </div>
                                            <div
                                              className={PanStyles.divid}
                                            ></div>
                                          </div>
                                          {isMobile && (
                                            <div
                                              className={PanStyles.googleMobile}
                                            >
                                              <ContinueWithGoogle
                                                handleCallBack={callBackMessage}
                                                handleCallBackSuccess={(
                                                  googleData: any,
                                                ) => {
                                                  setFieldValue(
                                                    "email",
                                                    googleData?.email,
                                                  );
                                                  setOtpSent(false);
                                                  setFieldValue(
                                                    "emailotp",
                                                    "123456",
                                                  );
                                                  handleCallBackSuccess(
                                                    googleData,
                                                  );
                                                }}
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </div> */}
                                    </div>

                                    <div className={PanStyles.buttonSection}>
                                      <div
                                        className={PanStyles.buttonSectionLeft}
                                      >
                                        {" "}
                                        I authorise FIRSTOCK to fetch my KYC
                                        information from the CKYC registry using
                                        my PAN
                                      </div>
                                      <div
                                        className={PanStyles.buttonSectionLeft}
                                      >
                                        {values.pannumber?.length > 9 &&
                                        values.fullName !== "" ? (
                                          <LoadingButton
                                            type="submit"
                                            variant="contained"
                                            loading={loading}
                                            id="panVerificationContinueButton"
                                            className={PanStyles.button}
                                            onClick={() => {
                                              handleSubmit();
                                            }}
                                          >
                                            {loading ? (
                                              <CircularProgress
                                                style={{
                                                  color: "inherit",
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                              />
                                            ) : (
                                              "Continue"
                                            )}
                                          </LoadingButton>
                                        ) : (
                                          <Button
                                            type="submit"
                                            variant="contained"
                                            disabled
                                            className={PanStyles.button}
                                          >
                                            Continue
                                          </Button>
                                        )}
                                      </div>
                                    </div>
                                  </form>
                                </>
                              );
                            }}
                          </Formik>
                        </>
                      ) : (
                        <>
                          <Backdrop
                            sx={{
                              color: "#fff",
                              zIndex: (theme) => theme.zIndex.drawer + 1,
                            }}
                            open={open}
                          >
                            <CircularProgress color="inherit" />
                          </Backdrop>
                        </>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <div className={PanStyles.fetchWrapper}>
                  <KRAScreen aadhaarData={KraData} />
                  <div
                    className={PanStyles.buttonSection}
                    // style={{
                    //   justifyContent: "flex-end",
                    // }}
                  >
                    <div className={PanStyles.buttonSectionLeft}>
                      <b> Note*</b> Please review your KRA details and verify to
                      proceed
                    </div>
                    <div className={PanStyles.buttonSectionRight}>
                      <Button
                        id="continue2"
                        variant="outlined"
                        className={PanStyles.fetchUpdate}
                        onClick={handleDigilocker}
                        sx={{ color: "var(--ds-text-primary)" }}
                      >
                        Update as on Aadhaar
                      </Button>
                      <Button
                        id="continue1"
                        variant="contained"
                        className={PanStyles.fetchContinue}
                        onClick={CompleteAadhaarStage}
                      >
                        Continue
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    </>
  );
}
